import React from 'react';
import { useTranslation } from 'react-i18next';

const AnalysisTabContent = () => {
    const { t } = useTranslation();

    return (
        <div className="analysis-tab-content">
            <div className="analysis-placeholder">
                <p>{t('priceSimulation.analysisComingSoon')}</p>
            </div>
        </div>
    );
};

export default AnalysisTabContent;
